import Story from './Story';
import storyValidator from './story-validator';
import defaultTemplate from './templates/default-template';

export default Story;
export { defaultTemplate };
export { storyValidator };
